import React from 'react';
import { PettyCash } from '../../../types';
import Button from '../Button';

interface PettyCashFormActionsProps {
  pettyCash?: PettyCash;
  isSubmitting: boolean;
  onCancel: () => void;
  onApprove?: (record: PettyCash) => void;
  onReject?: (record: PettyCash) => void;
}

const PettyCashFormActions: React.FC<PettyCashFormActionsProps> = ({
  pettyCash,
  isSubmitting,
  onCancel,
  onApprove,
  onReject
}) => {
  return (
    <div className="flex justify-between items-center">
      {pettyCash && pettyCash.status === 'pending' && onApprove && onReject && (
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={() => onApprove(pettyCash)}
            className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 font-medium"
          >
            ✓ Approve Record
          </button>
          <button
            type="button"
            onClick={() => onReject(pettyCash)}
            className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 font-medium"
          >
            ✕ Reject Record
          </button>
        </div>
      )}
      
      <div className="flex space-x-4 ml-auto">
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Saving...' : (pettyCash ? 'Update Record' : 'Create Record')}
        </Button>
      </div>
    </div>
  );
};

export default PettyCashFormActions;
